import { rankingCards } from '../../../mocks/ranking-cards';

export default function RankingList() {
  // Filter cards with free annual fee
  const freeCards = rankingCards.filter(card => card.annualFee === '永年無料');

  return (
    <section id="ranking" className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#003366] mb-12">
          年会費無料カードおすすめランキング
        </h2>

        <div className="space-y-8">
          {freeCards.map((card, index) => (
            <div
              key={card.id}
              className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow overflow-hidden border border-gray-200"
            >
              <div className="p-6 md:p-8">
                <div className="flex flex-col md:flex-row gap-6">
                  {/* Rank Badge */}
                  <div className="flex-shrink-0">
                    <div className={`w-20 h-20 flex items-center justify-center rounded-full font-bold text-2xl ${
                      index === 0 ? 'bg-[#FFD700] text-white' :
                      index === 1 ? 'bg-[#C0C0C0] text-white' :
                      index === 2 ? 'bg-[#CD7F32] text-white' :
                      'bg-gray-200 text-gray-700'
                    }`}>
                      {index + 1}位
                    </div>
                  </div>

                  {/* Card Info */}
                  <div className="flex-1">
                    <div className="flex flex-col md:flex-row md:items-start gap-6 mb-6">
                      {/* Logo */}
                      <div className="w-48 h-32 flex items-center justify-center bg-gray-50 rounded-lg p-4">
                        <img
                          src={card.logo}
                          alt={card.name}
                          className="w-full h-full object-contain"
                        />
                      </div>

                      {/* Details */}
                      <div className="flex-1">
                        <h3 className="text-2xl font-bold text-[#003366] mb-4">{card.name}</h3>
                        
                        <div className="grid grid-cols-2 gap-4 mb-4">
                          <div>
                            <p className="text-sm text-gray-600 mb-1">還元率</p>
                            <p className="text-xl font-bold text-[#FF9900]">{card.returnRate}</p>
                          </div>
                          <div>
                            <p className="text-sm text-gray-600 mb-1">年会費</p>
                            <p className="text-xl font-bold text-[#003366]">{card.annualFee}</p>
                          </div>
                        </div>

                        {/* Benefits */}
                        <div className="space-y-2 mb-6">
                          <p className="text-sm font-bold text-gray-700 mb-2">おすすめポイント</p>
                          {card.benefits.map((benefit, idx) => (
                            <div key={idx} className="flex items-start gap-2">
                              <i className="ri-check-line text-[#FF9900] text-lg flex-shrink-0 w-6 h-6 flex items-center justify-center"></i>
                              <p className="text-gray-700 text-sm">{benefit}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    {/* CTA Buttons */}
                    <div className="flex flex-col sm:flex-row gap-3">
                      <a
                        href={card.officialUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex-1 bg-[#FF9900] hover:bg-[#E68A00] text-white font-bold px-6 py-3 rounded-lg transition-all text-center cursor-pointer whitespace-nowrap"
                      >
                        公式サイトを見る
                      </a>
                      <a
                        href={card.detailUrl}
                        className="flex-1 bg-white hover:bg-gray-50 text-[#003366] font-bold px-6 py-3 rounded-lg border-2 border-[#003366] transition-all text-center cursor-pointer whitespace-nowrap"
                      >
                        詳細を見る
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
